<template>
  <section>
    <v-row class="align-center">
        <v-col cols="12" sm="12" lg="6" class="text-center text-md-left">
            <span class="text-h6 ">{{ headerTitle }}</span>
        </v-col>
        <v-col cols="12" sm="12" lg="6">
            <v-breadcrumbs :items="items" divider="/" class="float-lg-right justify-center"></v-breadcrumbs>
        </v-col>
    </v-row>
  </section>
</template>
<script>
  export default {
    props: ['headtitle', 'breadcrumbcurrent'],
    data(){
        return{
            items: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: './dashboard',
                },
            ],
            headerTitle: this.headtitle,
        };
    },
    methods:{
        breadcrumb(){
            if(this.breadcrumbcurrent){
                this.items.push({
                    text: this.breadcrumbcurrent,
                    disabled: true,
                    href: '#',
                });
            }else{
                this.items[0].disabled = true;
            }
        }
    },
    created(){
        this.breadcrumb();
    }
  }
</script>